import { useEffect, useRef } from 'react';

export const useBodyScrollLock = (isLocked: boolean) => {
    const originalStylesRef = useRef<{
        overflow: string;
        position: string;
        top: string;
        width: string;
    } | null>(null);
    const scrollPositionRef = useRef<number>(0);

    useEffect(() => {
        const body = document.body;

        if (!body) return;

        if (isLocked) {
            // Only lock if not already locked
            if (body.style.position !== 'fixed') {
                // Store scroll position and original styles
                scrollPositionRef.current = window.scrollY;
                originalStylesRef.current = {
                    overflow: body.style.overflow || '',
                    position: body.style.position || '',
                    top: body.style.top || '',
                    width: body.style.width || '',
                };

                // Apply lock styles
                body.style.overflow = 'hidden';
                body.style.position = 'fixed';
                body.style.top = `-${scrollPositionRef.current}px`;
                body.style.width = '100%';
            }
        } else {
            // Unlock scroll
            if (body.style.position === 'fixed' && originalStylesRef.current) {
                // Restore original styles
                body.style.overflow = originalStylesRef.current.overflow;
                body.style.position = originalStylesRef.current.position;
                body.style.top = originalStylesRef.current.top;
                body.style.width = originalStylesRef.current.width;

                // Restore scroll position
                window.scrollTo(0, scrollPositionRef.current);

                // Clear the stored styles
                originalStylesRef.current = null;
            }
        }

        // Cleanup function
        return () => {
            if (!isLocked && body.style.position === 'fixed' && originalStylesRef.current) {
                body.style.overflow = originalStylesRef.current.overflow;
                body.style.position = originalStylesRef.current.position;
                body.style.top = originalStylesRef.current.top;
                body.style.width = originalStylesRef.current.width;
                window.scrollTo(0, scrollPositionRef.current);
                originalStylesRef.current = null;
            }
        };
    }, [isLocked]);

    // Force cleanup on unmount
    useEffect(() => {
        return () => {
            const body = document.body;
            if (body && body.style.position === 'fixed') {
                body.style.overflow = '';
                body.style.position = '';
                body.style.top = '';
                body.style.width = '';
            }
        };
    }, []);
};